import React from 'react'
import { useFela } from 'react-fela'
import {
  formControlBackground,
  grayInput,
  grayInputBackground,
  grayInputBorder,
  pathspotOffWhite,
  pathspotPrimary,
  pathspotWhite,
} from '../../../styles/ts/colors'
import DatePicker from 'react-datepicker'
import { Atomic } from '../../..'
import { FD } from '../../api/atomic.constants'
import { PathSpotDecrement, PathSpotIncrement } from '../../../assets/icons/pathspot/catalog'
import 'react-datepicker/dist/react-datepicker.css'

const daySelector = (args: any) => {
  if (FD.DAYSELECT) console.log('Args in dayselector are: ', args)
  const { height, border, color, backgroundColor, fontSize, textAlign, justifyContent, alignItems } = args
  const { borderRadius, borderColor, borderWidth, borderStyle } = border || {}
  return {
    color: color || grayInput,
    backgroundColor: backgroundColor || formControlBackground,
    height: height || '2rem',
    justifyContent: justifyContent || 'center',
    textAlign: textAlign || 'center',
    fontSize: fontSize || '1.15rem',
    borderColor: borderColor || grayInputBorder,
    borderWidth: borderWidth || '1px',
    borderRadius: borderRadius || '0.25rem',
    borderStyle: borderStyle || 'solid',
    boxShadow:
      '0 1px 1px 0 rgba(var(--elevation-base-color), .14), 0 2px 1px -1px rgba(var(--elevation-base-color), .12), 0 1px 3px 0 rgba(var(--elevation-base-color), .20)',
  }
}

const PDaySelector = (props: any) => {
  const { selectedDate, setSelectedDate, width, border, height, onNextDay, onPreviousDay } = props
  const { css } = useFela()
  return (
    <Atomic.PElement isRow width={width} border={{ ...border }} justifyContent="center" alignItems="center" showComment={true}>
      <Atomic.PIconButton
        PathSpotIcon={PathSpotDecrement}
        iconName="PathSpotDecrement"
        width="25%"
        button={{ height: height, color: grayInput, backgroundColor: formControlBackground }}
        iconStrokeColor={grayInput}
        iconFillColor={grayInput}
        onClick={onPreviousDay}
      />
      <DatePicker
        className={css(daySelector({ height }))}
        selected={selectedDate}
        onSelect={setSelectedDate}
        onChange={setSelectedDate} //only when value has changed
      />
      <Atomic.PIconButton
        PathSpotIcon={PathSpotIncrement}
        iconName="PathSpotIncrement"
        width="25%"
        button={{ height: height, color: grayInput, backgroundColor: formControlBackground }}
        iconStrokeColor={grayInput}
        iconFillColor={grayInput}
        onClick={onNextDay}
      />{' '}
    </Atomic.PElement>
  )
}
export default PDaySelector
